
const deviceMoudle={
  namespaced: true,
  state:{
    searchSN:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default deviceMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/device.js